import BaseClient from '@/app/model/api/response/baseApiClient'

class AiAdviceCreateApi extends BaseClient {
  public doAiAdviceCreate (bodyData: {[key:string]: string|number|number[]}) {
    const path:string = '/v1/ai-advice'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new AiAdviceCreateApi()
